import { useGoBack } from '~/shared/routing/useGoBack';
import { Button } from '~/shared/components/buttons/Button';
import { X } from 'lucide-react';

export interface CancelButtonProps {
	onCancel?: () => void;
	goBackOnCancel?: boolean;
}

export function CancelButton(props: CancelButtonProps) {
	const goBack = useGoBack();
	return (
		<Button
			type="button"
			appearance="outline"
			intent="neutralLight"
			onClick={props.goBackOnCancel ? goBack : props.onCancel}
			Icon={X}
			label="Cancel"
		/>
	);
}
